import React from "react";
import RegistroReclamos from "src/components/Reclamos/RegistroReclamo";
import CabeceraFecha from "src/components/CabeceraFecha";
import {
  compararHistorialFecha,
  conseguirGrupoDeFechasActual,
  ReclamosProps,
  RegistroReclamo,
} from "src/utils";
import { withRouter } from "react-router";

const Reclamos: React.FC<ReclamosProps> = (props: ReclamosProps) => {
  // Si el cargo posee la palabra fiscal
  const esFiscal = props.cargo?.toLowerCase().includes('fiscal');

  const reclamos = esFiscal
    ? props.registros.filter((registro) => registro.estado === "ABIERTO")
    : props.registros;

  return (
    <>
      {reclamos.map((registro, idx) => {
        let registroAnterior: RegistroReclamo | null = null;

        if (idx !== 0) registroAnterior = reclamos[idx - 1];

        const sinCabecera =
          registroAnterior &&
          compararHistorialFecha(registro, registroAnterior) === 0;

        const grupoDeFechasActual = conseguirGrupoDeFechasActual(
          props.fechasDeGrupos,
          registro
        );

        return (
          <React.Fragment key={registro.id}>
            {!sinCabecera && <CabeceraFecha {...grupoDeFechasActual} />}

            <RegistroReclamos {...registro} cargo={props.cargo} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default withRouter(Reclamos);
